module.exports = __webpack_public_path__ + "img/partPlaceholder.a4cd1320.jpg";